import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './AdminDashboard.css';

const SECTIONS = [
  {
    id: 'contenido',
    title: 'Contenido Publico',
    description: 'Gestion del contenido que se publica en el sitio institucional.',
    cards: [
      { to: '/admin/noticias', title: 'Noticias', desc: 'Gestionar noticias y publicaciones', icon: '📰' },
      { to: '/admin/convocatorias', title: 'Convocatorias', desc: 'Gestionar convocatorias y anuncios', icon: '📢' },
      { to: '/admin/gaceta', title: 'Gaceta', desc: 'Gestionar documentos de gaceta', icon: '📄' },
      { to: '/admin/transparencia', title: 'Transparencia', desc: 'Gestionar documentos de transparencia', icon: '🔍' },
      { to: '/admin/sesiones', title: 'Sesiones', desc: 'Gestionar sesiones del concejo', icon: '📋' },
      { to: '/admin/galeria', title: 'Galeria', desc: 'Gestionar fotografias y videos', icon: '📸' },
      { to: '/admin/encuestas', title: 'Encuestas', desc: 'Gestionar encuestas ciudadanas', icon: '📊' },
      { to: '/admin/historia', title: 'Historia', desc: 'Gestionar historia del Concejo', icon: '📜' }
    ]
  },
  {
    id: 'institucional',
    title: 'Institucional',
    description: 'Estructura del concejo, autoridades y planificacion anual.',
    cards: [
      { to: '/admin/autoridades', title: 'Autoridades', desc: 'Gestionar mesa directiva, concejales y fotos', icon: '👥' },
      { to: '/admin/plan-accion', title: 'Plan de Accion', desc: 'Editar vigencia, mesa directiva y cronograma', icon: '🗂️' },
      { to: '/admin/tramites', title: 'Tramites', desc: 'Gestionar tramites del Concejo', icon: '📌' }
    ]
  },
  {
    id: 'participacion',
    title: 'Participacion Ciudadana',
    description: 'Canales de interaccion, consulta y control social.',
    cards: [
      { to: '/admin/pqrsd', title: 'PQRSD', desc: 'Gestionar peticiones, quejas, reclamos y sugerencias', icon: '📝' },
      { to: '/admin/opiniones', title: 'Opiniones', desc: 'Gestionar opiniones sobre proyectos', icon: '💬' },
      { to: '/admin/foros', title: 'Foros', desc: 'Gestionar foros de discusion', icon: '🗣️' }
    ]
  },
  {
    id: 'sistema',
    title: 'Sistema y Soporte',
    description: 'Configuracion general, usuarios y repositorio documental.',
    cards: [
      { to: '/admin/configuracion', title: 'Configuracion', desc: 'Configuracion general del sitio', icon: '⚙️' },
      { to: '/admin/usuarios', title: 'Usuarios', desc: 'Gestionar usuarios y permisos', icon: '👤' },
      { to: '/admin/repositorio', title: 'Repositorio', desc: 'Revisar, organizar y mover documentos', icon: '📁' }
    ]
  }
];

const AdminDashboard = () => {
  const { user, logout } = useAuth();

  return (
    <div className="admin-dashboard">
      <div className="dashboard-header">
        <div className="container">
          <h1>Panel de Administración</h1>
          <p className="dashboard-subtitle">
            Estructura organizada por modulos, similar al panel de Diocesis.
          </p>
          <div className="dashboard-user">
            <span>Bienvenido, {user?.nombre || user?.email}</span>
            <button onClick={logout} className="btn btn-secondary">
              Cerrar Sesión
            </button>
          </div>
        </div>
      </div>

      <div className="dashboard-content">
        <div className="container">
          {SECTIONS.map((section) => (
            <section key={section.id} className="dashboard-section">
              <h2 className="dashboard-section-title">{section.title}</h2>
              <p className="dashboard-section-description">{section.description}</p>
              <div className="dashboard-grid">
                {section.cards.map((card) => (
                  <Link key={card.to} to={card.to} className="dashboard-card">
                    <h3>{card.icon} {card.title}</h3>
                    <p>{card.desc}</p>
                  </Link>
                ))}
              </div>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;


